export * from './filter';

import { FilterComponent } from './filter';

export const FilterOrganisms = [
    FilterComponent
]